import React from 'react';
import styles from './index.module.scss';

import Hero from './new-hero';
import WhatsNew from './whats-new';
import classnames from 'classnames';
import ExistingCustomers from '../home-V2/existing-customers/loadable';
// import Solutions from './solutions';
import Growth from './growth';
import Video from './vid';
import Products from './products';
import GetInvolved from './get-involved';
// import Help from './help';
// import TwoPointZero from './two-point-zero';
// import BehindTheSkills from './skills';
// import Testimonials from './testimonials';
import AsSeen from './as-seen';
// import AnimatedBackgroundDesktop from '../../common/animated-background/desktop-version';
// import themeConfig from '../../theme/config';
// import MediaQuery from 'react-responsive';
// import HOMEPAGE_HERO_IMG from './hero/homepage-hero2.svg';

const home = props => {
  return (
    <div>
      <div className={styles.container}>
        {/* <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
          <AnimatedBackgroundDesktop />
        </MediaQuery> */}
        <Hero />
      </div>
      <div className={classnames(styles.container, styles.customers)}>
        <ExistingCustomers autoplay={true} dots={false} />
      </div>
      {/* <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
        <div className={classnames(styles.bgLarge)} />
      </MediaQuery> */}
      <div className={styles.lightBgWrapper}>
        <div className={styles.container}>
          <WhatsNew />
        </div>
      </div>
      <div className={styles.container}>
        <Growth />
      </div>
      <div className={styles.lightBgWrapper}>
        <div className={styles.container}>
          <Video />
        </div>
      </div>
      <div className={styles.darkBlueBgWrapper}>
        <div className={styles.container}>
          <Products />
        </div>
      </div>
      <div className={styles.container}>
        <GetInvolved />
      </div>
      {/* <div className={classnames(styles.skillGrid)}>
        <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
          <div className={classnames('d-flex justify-content-between', styles.absContainer)}>
            <div className={styles.highlighted} />
            <div />
          </div>
        </MediaQuery>
        <div className={classnames(styles.container)}>
          <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
            <div className={classnames(styles.skills)}>
              <BehindTheSkills />
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.lg - 1}>
            <BehindTheSkills />
          </MediaQuery>
        </div>
      </div> */}
      {/* <div className={styles.testimonials}>
        <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
          <div className={classnames('d-flex justify-content-between', styles.absContainer)}>
            <div />
            <div className={styles.testimonialsBg} />
          </div>
        </MediaQuery>
        <div className={classnames(styles.container)}>
          <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.lg}>
            <div className={classnames(styles.temp)}>
              <Testimonials />
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.lg - 1}>
            <Testimonials />
          </MediaQuery>
        </div>
      </div> */}
      <div className={classnames(styles.container, styles.asSeen)}>
        <AsSeen showMediaOnly />
      </div>
    </div>
  );
};

export default home;
